(ns machtfit.format
  (:import goog.i18n.NumberFormat)
  (:require [cljs-time.coerce :as time.coerce]
            [cljs-time.format :as time.format]))

(defn decimal [n]
  (let [formatter (NumberFormat. NumberFormat.Format.DECIMAL)]
    (.format formatter n)))

(defn currency [n]
  (let [formatter (NumberFormat. NumberFormat.Format.CURRENCY "EUR")]
    (.format formatter n)))

(defn date->name [date]
  (time.format/unparse (time.format/formatter "yyyy-MM-dd") date))

(defn date->keyword [date]
  (keyword (date->name date)))

(defn keyword->date [#_:clj-kondo/ignore keyword]
  (-> keyword name time.coerce/to-date-time))

(defn name->date [name]
  (time.coerce/to-date-time name))

(defn date->short [date]
  (time.format/unparse (time.format/formatter "dd.MM") date))
